module.exports = __webpack_public_path__ + "img/private-icon.6e875e6.png";